namespace RedBullMOBILE360.SpecialEvent {
    export interface SpecialEventImportForm {
        EventName: Serenity.StringEditor;
        ImageUrl: Serenity.ImageUploadEditor;
        UploadDate: Serenity.DateEditor;
    }

    export class SpecialEventImportForm extends Serenity.PrefixedContext {
        static formKey = 'SpecialEvent.SpecialEventImport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SpecialEventImportForm.init)  {
                SpecialEventImportForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.ImageUploadEditor;
                var w2 = s.DateEditor;

                Q.initFormType(SpecialEventImportForm, [
                    'EventName', w0,
                    'ImageUrl', w1,
                    'UploadDate', w2
                ]);
            }
        }
    }
}
